import { Link } from "react-router-dom";
import { Phone, Mail, MapPin, FileText, Clock } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const LOGO_URL =
  "https://customer-assets.emergentagent.com/job_db8a839c-b509-45fe-9b58-2aa5c19d0b7d/artifacts/xdtcc51o_Gemini_Generated_Image_u8x0fqu8x0fqu8x0.png";

export const Footer = () => {
  const currentYear = new Date().getFullYear();
  const { t } = useLanguage();

  return (
    <footer data-testid="footer" className="bg-slate-900 text-white">
      <div className="max-w-7xl mx-auto px-6 md:px-12 py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Logo and Description */}
          <div className="lg:col-span-1">
            <img
              src={LOGO_URL}
              alt="FastCar Logo"
              className="h-16 w-auto mb-6 brightness-0 invert"
            />
            <p className="text-slate-400 leading-relaxed mb-6">
              {t("footer.description")}
            </p>
            <div className="badge-billing bg-emerald-900/30 border-emerald-700 text-emerald-400">
              <FileText className="w-4 h-4" />
              <span>{t("nav.billingAvailable")}</span>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-white">
              {t("footer.quickLinks")}
            </h4>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  data-testid="footer-link-inicio"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {t("nav.home")}
                </Link>
              </li>
              <li>
                <Link
                  to="/acerca"
                  data-testid="footer-link-acerca"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {t("nav.about")}
                </Link>
              </li>
              <li>
                <Link
                  to="/servicios"
                  data-testid="footer-link-servicios"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {t("nav.services")}
                </Link>
              </li>
              <li>
                <Link
                  to="/contacto"
                  data-testid="footer-link-contacto"
                  className="text-slate-400 hover:text-white transition-colors"
                >
                  {t("nav.contact")}
                </Link>
              </li>
            </ul>
          </div>

          {/* Services */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-white">
              {t("footer.servicesTitle")}
            </h4>
            <ul className="space-y-3">
              <li className="text-slate-400">{t("services.airport.title")}</li>
              <li className="text-slate-400">
                {t("services.corporate.title")}
              </li>
              <li className="text-slate-400">{t("services.events.title")}</li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="font-semibold text-lg mb-6 text-white">
              {t("footer.contactTitle")}
            </h4>
            <ul className="space-y-4">
              <li className="flex items-center gap-3 text-slate-400">
                <Phone className="w-5 h-5 text-sky-500" />
                <span>+52 (55) 1234-5678</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Mail className="w-5 h-5 text-sky-500" />
                <span>info@fastcar.mx</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <MapPin className="w-5 h-5 text-sky-500" />
                <span>Ciudad de México, MX</span>
              </li>
              <li className="flex items-center gap-3 text-slate-400">
                <Clock className="w-5 h-5 text-sky-500" />
                <span>24/7</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {currentYear} FastCar. {t("footer.rights")}
          </p>
          <p className="text-slate-500 text-sm flex items-center gap-2">
            Desarrollado por{" "}
            <a className="hover:text-sky-500" href="https://jupitersoft.tech/">
              JupiterSoftTech
            </a>
          </p>
        </div>
      </div>
    </footer>
  );
};
